var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.25 5.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0zM6.5 3.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.75 13c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v1a.75.75 0 1 0 1.5 0v-1A2.75 2.75 0 0 0 8 10.25H4A2.75 2.75 0 0 0 1.25 13v1a.75.75 0 1 0 1.5 0v-1zM12 10.25a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 1 .75.75V14a.75.75 0 1 0 1.5 0v-1.5a2.25 2.25 0 0 0-2.25-2.25H12zM14.25 5.5A3.25 3.25 0 0 0 11 2.25a.75.75 0 0 0 0 1.5 1.75 1.75 0 0 1 0 3.5.75.75 0 0 0 0 1.5 3.25 3.25 0 0 0 3.25-3.25z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup);
export default ForwardRef;